import {useContext} from 'react';
import {
	AppBar,
	Toolbar,
	List,
	ListItem,
	ListItemText,
	Button,
	Link,
	makeStyles,
	useTheme,
	useMediaQuery
} from '@material-ui/core';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import EuroIcon from '@material-ui/icons/Euro';
import FacebookIcon from 'assets/icons/facebook.png';
import InstagramIcon from 'assets/icons/instagram.png';
import TripadvisorIcon from 'assets/icons/tripadvisor.png';
import PopoverComponent from 'components/PopoverComponent';
import {AuthContext} from 'context/AuthContext';
import {ProfileContext} from 'context/ProfileContext';
import {currencyFormatterDecimal} from 'helpers/currency.helper';
import {useHistory, Link as RouterLink} from 'react-router-dom';
import ROLES from 'constants/role.contstants';
import profile from 'assets/icons/Profile.png';
import logOut from 'assets/icons/LogOut.png';
import SettingsIcon from '@material-ui/icons/Settings';

export const social = [
	{
		icon: FacebookIcon,
		url: 'https://www.facebook.com/HotTours/'
	},
	{
		icon: InstagramIcon,
		url: 'https://instagram.com/hottoursarmenia?igshid=YmMyMTA2M2Y='
	},
	{
		icon: TripadvisorIcon,
		url: 'https://www.tripadvisor.com/Attraction_Review-g293932-d15274945-Reviews-Hot_Tours_Armenia-Yerevan.html'
	}
];

export const Social = () => {
	const localSocial = [...social];
	return (
		<>
			{localSocial.map((el, i: number) => (
				<Link key={i} href={el.url} underline="none" color="inherit" target="_blank">
					<img src={el.icon} alt={'icon'} width="20" style={{marginRight: 10}} />
				</Link>
			))}
		</>
	);
};

const useStyles = makeStyles(theme => ({
	container: {
		boxShadow: 'unset',
		color: 'black',
		backgroundColor: 'white',
		[theme.breakpoints.down('sm')]: {
			display: 'none'
		}
	},
	toolbar: {
		display: 'flex',
		justifyContent: 'space-between',
		paddingLeft: 24
	},
	balance: {
		display: 'flex',
		fontSize: 16,
		fontWeight: 500,
		marginRight: 10
	},
	leftBlock: {
		display: 'flex',
		'& a': {
			marginRight: 10,
			display: 'flex',
			alignItems: 'center'
		},
		'& hr': {
			margin: '0 12px 0 5px'
		}
	},
	rightBlock: {
		display: 'flex',
		alignItems: 'center',
		[theme.breakpoints.down('md')]: {
			display: 'none'
		},
		borderRadius: 15,
		backgroundColor: '#fafafa',
		padding: '10px 10px 10px 20px'
	},
	socialButton: {
		color: 'inherit'
	},
	menuItem: {
		background: theme.palette.primary.main,
		display: 'flex',
		justifyContent: 'center',
		height: 'fit-content',
		padding: '10px 30px',
		'&:hover': {
			background: theme.palette.primary.light
		}
	},
	list: {
		fontWeight: 500,
		fontSize: 18,
		color: '#7D8494'
	}
}));

const AppBarComponent = () => {
	const classes = useStyles();
	const history = useHistory();
	const {dispatch: authDispatch} = useContext(AuthContext);
	const {state: profileState} = useContext(ProfileContext);
	const userInfo = profileState.companyName + ' - ' + profileState.contactNameSurname;
	const theme = useTheme();

	const ROLE =
		profileState.adminGroups && profileState.adminGroups !== '...'
			? profileState.adminGroups
			: profileState.role;

	const handleLogout = () => {
		authDispatch({
			type: 'LOGOUT'
		});
	};

	return (
		<AppBar color="primary" position="static" className={classes.container}>
			<Toolbar className={classes.toolbar} variant="dense">
				<div className={classes.leftBlock}>
					{/* {useMediaQuery(theme.breakpoints.up('md')) ? (
						<>
							<img src={phone} alt="phone" style={{margin: '0 20px 0 20px'}} />
							<Link href="tel:+1234567890" underline="none" color="inherit">
								(Viber/WhatsApp) +37443779000
							</Link>
							<Divider orientation="vertical" flexItem style={{backgroundColor: '#fff'}} />
						</>
					) : null}
					<Social /> */}
				</div>

				<div className={classes.rightBlock}>
					<div className={classes.balance}>
						{/* <img src={AMD} alt="amd" height="16" style={{margin: '2px 10px 0 15px'}} />{' '} */}
						{currencyFormatterDecimal(profileState.balance)}
					</div>
					<span>|</span>
					<Button component={RouterLink} to={'/currency'} color="inherit">
						<div
							style={{
								display: 'flex',
								flexDirection: useMediaQuery(theme.breakpoints.down('md')) ? 'column' : 'row',
								justifyContent: 'center',
								alignItems: 'center',
								width: 'fit-content',
								height: '100%',
								fontSize: 16
							}}
							color="inherit">
							<div style={{display: 'flex', alignItems: 'center', marginRight: 10}}>
								<AttachMoneyIcon fontSize="small" />
								{profileState.usdRate}
							</div>
							<div style={{display: 'flex', alignItems: 'center', marginRight: 10}}>
								<EuroIcon fontSize="small" style={{marginRight: 3}} />
								{profileState.eurRate}
							</div>
						</div>
					</Button>
					<span>|</span>
					<PopoverComponent title={userInfo}>
						<List component="nav" className={classes.list}>
							{(ROLE === ROLES.ADMIN ||
								ROLE === ROLES.SUPER_ADMIN ||
								ROLE === ROLES.VIEWER ||
								ROLE === ROLES.ADMIN_TICKETS) && (
								<ListItem button onClick={() => history.push(`/settings`)}>
									<SettingsIcon style={{marginRight: 15}} />
									<ListItemText primary="Settings" />
								</ListItem>
							)}
							<ListItem button onClick={() => history.push(`/profile`)}>
								<img src={profile} alt="profile icon" style={{marginRight: 15}} />
								<ListItemText primary="My Profile" />
							</ListItem>
							<ListItem button onClick={handleLogout}>
								<img src={logOut} alt="LogOut icon" style={{marginRight: 15}} />
								<ListItemText primary="Log out" />
							</ListItem>
						</List>
					</PopoverComponent>
				</div>
			</Toolbar>
		</AppBar>
	);
};

export default AppBarComponent;
